import Logo from '../Logo';
import { StyledHeader } from './Header.styles';

function Header() {
  return (
    <StyledHeader>
      <Logo />
    </StyledHeader>
  );
}

export default Header;
